import Typography from "../../Utility/Typography";

/**
 * Jira-style epic completion bar (design — computed from child issue rows).
 */
export default function EpicChildProgressBar({ doneCount = 0, totalCount = 0, className = "" }) {
  const total = Math.max(0, Number(totalCount) || 0);
  const done = Math.min(Math.max(0, Number(doneCount) || 0), total);
  const openCount = total - done;
  const percent = total === 0 ? 0 : Math.round((done / total) * 100);

  return (
    <div className={`epic-child-progress ${className}`.trim()} aria-label="Epic progress">
      <div className="epic-child-progress__header">
        <Typography variant="text2" className="epic-child-progress__stat !mb-0">
          <span className="epic-child-progress__percent">{percent}%</span>
          <span className="epic-child-progress__detail">
            {done} of {total} complete
          </span>
        </Typography>
        {total > 0 ? (
          <Typography variant="text2" className="epic-child-progress__open !mb-0">
            {openCount} open
          </Typography>
        ) : null}
      </div>
      <div
        className="epic-child-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        aria-valuetext={`${percent}% complete, ${done} of ${total} work items`}
      >
        <div className="epic-child-progress__fill" style={{ width: `${percent}%` }} />
      </div>
      {total > 0 ? (
        <div className="epic-child-progress__legend" aria-hidden>
          <span className="epic-child-progress__legend-item epic-child-progress__legend-item--done">
            Done {done}
          </span>
          <span className="epic-child-progress__legend-item epic-child-progress__legend-item--open">
            Open {openCount}
          </span>
        </div>
      ) : null}
    </div>
  );
}
